//#region [IMPORT]

import React, { createContext, useEffect, useState } from "react";
import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

//#region [VALUES]

const AppContext = createContext()

//#endregion

//-----------------------------------------------------------------
function AppProvider( { children } ) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  //#endregion

  //#region [EFFECT]

  //#endregion

  return (
    <AppContext.Provider value={ {} }>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };